import styled from 'styled-components';
import { colors, font } from '@chegg-ui/theme';
import { Link } from '@chegg-ui/link';
var dark = colors.dark,
  white = colors.white;
var size = font.size,
  weight = font.weight,
  family = font.family,
  lineHeight = font.lineHeight;
var px12 = size.px12,
  px14 = size.px14,
  px16 = size.px16;
var medium = weight.medium,
  bold = weight.bold;
var aspira = family.aspira;
export var TermsLink = styled(Link).withConfig({
  componentId: "sc-11sc662-0"
})(["font-size:", ";font-weight:", ";"], px12, medium);
export var TermsAndConditionsContainer = styled.span.withConfig({
  componentId: "sc-11sc662-1"
})(["font-family:", ";font-size:", ";text-align:left;white-space:break-spaces;h3{font-size:2rem;font-weight:bold;margin:10px 0;}h4{margin:20px 0;}"], aspira, px12);
export var BillingHeading = styled.h2.withConfig({
  componentId: "sc-11sc662-2"
})(["", ""], function (_ref) {
  var dcoExperimentVariationEnabled = _ref.dcoExperimentVariationEnabled;
  if (dcoExperimentVariationEnabled) {
    return "\n            font-weight: ".concat(bold, ";\n            font-size: ").concat(px12, ";\n            display: inline-block;\n            margin-bottom: 5px;\n            margin-right: 4px;\n          ");
  } else {
    return "\n            font-weight: ".concat(bold, ";\n            margin-bottom: 5px;\n            font-size: ").concat(px14, ";\n          ");
  }
});
export var TncModalContent = styled.div.withConfig({
  componentId: "sc-11sc662-3"
})(["p{font-family:", ";color:", ";font-size:", ";line-height:", ";margin:14px 0;}"], aspira, dark, px16, lineHeight.md);
export var InlineTncWrapper = styled.div.withConfig({
  componentId: "sc-11sc662-4"
})(["position:relative;font-size:1rem;line-height:1.5;:focus{outline:none;}h2{font-size:2rem;}"]);
export var StickyContainer = styled.div.withConfig({
  componentId: "sc-11sc662-5"
})(["position:sticky;height:80px;background-color:", ";bottom:-1px;padding-bottom:1px;"], white);
export var FlexContainer = styled.div.withConfig({
  componentId: "sc-11sc662-6"
})(["height:100%;display:flex;align-items:center;justify-content:center;"]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/TermsAndConditions/styled.js
// module id = 847
// module chunks = 11